const Account = () => import('./Account.vue')

const List = () => import('./pages/List.vue')
const Create = () => import('./pages/Create.vue')
const Edit = () => import('./pages/Edit.vue')

const routes = {
  component: Account,
  path: '/contas',
  meta: {
    label: 'Contas'
  },
  children: [
    {
      path: '',
      component: List,
      name: 'accountsList',
      meta: {
        label: 'Gerenciar Contas',
        requiredPermission: {resource: 'account', value: 'view'}
      }
    },
    {
      path: 'cadastro',
      component: Create,
      name: 'accountCreate',
      meta: {
        hidden: true,
        label: 'Cadastrar',
        requiredPermission: {resource: 'account', value: 'manage'}
      }
    },
    {
      path: 'atualizar/:id',
      component: Edit,
      name: 'accountEdit',
      meta: {
        hidden: true,
        label: 'Atualizar',
        requiredPermission: {resource: 'account', value: 'manage'}
      }
    }
  ]
}

export default routes



// WEBPACK FOOTER //
// ./src/pages/account/routes.js